import moment from 'moment';
import validator from 'validator'

export const ruleValidation = (value, rules, value2) => {

  let response = false;

  if(value !== null){
    switch (rules.type) {
      case 'distance':
        const min = rules.min !== null && rules.min !== undefined ? rules.min : 0
        const max = rules.max !== null && rules.max !== undefined ? rules.max : 255 
        if(value.length > min-1 && value.length < max + 1){
          response = true;
        }
        break;
      case 'numeric':
        const minN = rules.min !== null && rules.min !== undefined ? rules.min : -999999999999999999999999999999999
        const maxN = rules.max !== null && rules.max !== undefined ? rules.max : 99999999999999999999999999999 
          if(parseFloat(value) > minN-1 && parseFloat(value) < maxN + 1){
            response = true;
          }
          break;
      case 'email':
        //const mailformat = /(?:[0-9a-zA-Z!#$%&'*+/=?^_`{|}~-]+(?:\.[0-9a-zA-Z!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[0-9a-zA-Z](?:[0-9a-zA-Z-]*[0-9a-zA-Z])?\.)+[0-9a-zA-Z](?:[0-9a-zA-Z-]*[0-9a-zA-Z])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[0-9a-zA-Z-]*[0-9a-zA-Z]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        ////console.log(value, value.match(mailformat))
        //if (value.match(mailformat)){
        //  response = true;
        //}
        response = validator.isEmail(value)
        break;
      case 'equals':
        response = value ===  value2;
        break;
      case 'phone_number':
        if(value.length > 9 && value.length < 13){
          response = true
        }
        break;
      case 'select':
        if(value !== '' && value !== null){
          response = true;
        }else{
          response = false;
        }
        break;
      case 'rfc':
        const rfcFormat = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
        if(value.match(rfcFormat)){
          response = true;
        };
        break;
      case 'none':
        console.log("Cai aqui")
        response = true;
        console.log(response)
        break;
      case 'date':
        response = moment(value).isValid();
        break;
      case 'time':
        response = moment(value,"HH:mm").isValid();
        break;
      case 'phone':
        const phoneFormat = /^(?:[0-9] ?){6,14}[0-9]$/;
        if(value.match(phoneFormat)) response = true
        break;
      case 'zip':
        const zipFormat = /^\d{3,5}$/;
        if(value.match(zipFormat)) response = true
        break;
      case 'dateRange':
        const minD = rules.min ? moment(rules.min) : moment('1970-01-01')
        const maxD = rules.max ? moment(rules.max) : moment('2099-01-01')
        const currentDate = moment(value)
        if(currentDate.isValid()){
          if(currentDate.diff(minD) >= 0 && currentDate.diff(maxD) <= 0) response = true
        }
        break;
      case 'password':
        //const passwordformat = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/
        const passwordformat = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$?¡\-_]).{8,20}$/
        if (value.match(passwordformat)){
          response = true;
        }
        break;
      case 'link':
        const urlformat = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
        if (value.match(urlformat)){
          response = true;
        }
        break; 
      default:
    }
  }else{
    if(rules.type === 'none'){
      response = true
    }
  }

  return response;
};

export const isFormValid = (data) => {
  let isValid = true;
  Object.keys(data).forEach((item,key) => {
    if(data[item].isRequired && !data[item].isValid){
      isValid = false;
    }
  })
  return isValid;
}

